export default __webpack_public_path__ + "static/media/Pro-8.a5c5a881.png";